<footer>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="footer-top">
                    <div class="row">

                        <div class="col-lg-6">
                            <div class="about-enago">
                                <h3>Sobre a Trinka</h3>
                                <p>
                                    A Trinka é um verificador gramatical de inglês com tecnologia de IA e assistente de redação de aprimoramento de linguagem,
                                    projetado para redação acadêmica e técnica. A Trinka corrige erros ortográficos contextuais
                                    e erros gramaticais avançados, fornecendo sugestões de escrita em tempo real. Suporte
                                    profissional e acadêmico para garantir uma redação formal, concisa e envolvente. As soluções
                                    corporativas da Trinka vêm com acesso ilimitado e ótimas opções de personalização para
                                    todos os recursos poderosos da Trinka.
                                </p>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="install-in">
                                <h3>Instalar para:</h3>
                                <ul>
                                    <li>
                                        <span class="browser-icon">
                                            <a routerLink="/wordplugin/">
                                                <img src="../../../assets/images/NewWordAdd_in.svg" alt="word add-in"> </a>
                                        </span>
                                        <span class="install-in-browser">
                                            <a routerLink="/wordplugin/">Microsoft Word para Windows</a>
                                        </span>
                                        <!-- <a routerLink="/wordplugin"></a> -->
                                    </li>
                                    <li>
                                        <span class="browser-icon">
                                            <a routerLink="/browser-plugin/">
                                                <img src="../../../assets/images/NewChromeFicon.svg" alt="chrome">
                                            </a>
                                        </span>
                                        <span class="install-in-browser">
                                            <a routerLink="/browser-plugin/">Google Chrome</a>
                                        </span>
                                    </li>
                                    <li>
                                        <span class="browser-icon">
                                            <a routerLink="/browser-plugin/">
                                                <img src="../../../assets/images/NewFirefoxFicon.svg" alt="firefox">
                                            </a>
                                        </span>
                                        <span class="install-in-browser">
                                            <a routerLink="/browser-plugin/">Mozilla Firefox</a>
                                        </span>
                                    </li>
                                    <li>
                                        <span class="browser-icon">
                                            <a routerLink="/browser-plugin/">
                                                <img src="../../../assets/images/EdgeWhite_BGAndOutline.svg" alt="edge" width="42">
                                            </a>
                                        </span>
                                        <span class="install-in-browser">
                                            <a routerLink="/browser-plugin">Microsoft Edge</a>
                                        </span>

                                    </li>
                                    <li>
                                        <span class="browser-icon">
                                            <img src="../../../assets/images/UpcomingWord.svg" alt="upcoming">
                                        </span>
                                        <span class="install-in-browser">MS Word para Mac OS</span>
                                    </li>
                                    <li>
                                        <span class="browser-icon upcoming-icon">
                                            <img src="../../../assets/images/UpcomingSafari_icon.png" alt="safari">
                                        </span>
                                        <span class="install-in-browser">Navegador Safari</span>
                                    </li>
                                </ul>
                            </div>
                            <div class="contact" id="footerEmailBox">
                                <form class="form-inline" (ngSubmit)="subscribeNow()" [formGroup]="footerFroms">
                                    <div class="form-group mx-sm-3 mb-2 ml-0" [ngClass]="(!footerFroms.get('footeremailform').valid && footerFroms.get('footeremailform').dirty) || (footerFroms.get('footeremailform').touched && footerFroms.get('footeremailform').pristine) ? 'TextFiledError' : '' ">

                                        <mat-form-field appearance="outline">
                                            <mat-label>Seu e-mail aqui para notícias Trinka</mat-label>
                                            <input matInput placeholder="" formControlName="footeremailform" class="form-control" name="email">
                                        </mat-form-field>
                                    </div>
                                    <button type="submit" [disabled]="!footerFroms.valid" id="footerSubscribe" class="btn btn-primary mb-2">Inscrever</button>
                                </form>
                            </div>

                        </div>


                    </div>
                    <div class="row">

                        <div class="col-lg-12">
                            <div class="row footer_menu_wrap">
                                <div class="col">
                                    <div class="footer_menu_one">
                                        <h3>Empresa</h3>
                                        <ul class="ftr-menu">
                                            <li>
                                                <a [routerLink]="['/aboutus']" routerLinkActive="active">Sobre nós</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/contactus']" routerLinkActive="active">Contato</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/workwithus']" routerLinkActive="active">Trabalhe conosco</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/affiliates']" routerLinkActive="active">Programa de Afiliados</a>
                                            </li>
                                            <!-- <li>
                                                <a [routerLink]="['/accomplishments']" routerLinkActive="active">Accomplishments</a>
                                            </li> -->
                                        </ul>
                                    </div>
                                    <div class="footer_menu_one">
                                        <h3>Saiba Mais</h3>
                                        <ul class="ftr-menu">
                                            <li>
                                                <a href="https://www.trinka.ai/blog/"  target="_blank">Blog</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/examples']" routerLinkActive="active">Exemplos</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/faqs']" routerLinkActive="active">FAQs</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="footer_menu_one">
                                        <h3>Características</h3>
                                        <ul class="ftr-menu">
                                            <li>
                                                <a [routerLink]="['/features']" routerLinkActive="active">Todos os recursos</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/plagiarism-check']" routerLinkActive="active">Verificação de Plágio</a>
                                            </li>
                                            <li>
                                                <a href="https://www.trinka.ai/pt/features/auto-file-edit" routerLinkActive="active">Edição automática de arquivos</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/latex-grammar-checker']" routerLinkActive="active">Verificador de Gramática LaTex</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/paraphraser']" routerLinkActive="active">Parafraseador On-line</a>
                                            </li>
                                            <li>
                                                <a href="https://www.trinka.ai/pt/features/publication-readiness-checks" routerLinkActive="active">Verificações de prontidão para publicação</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/citation-checker']" routerLinkActive="active">Verificador de Citações</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/consistency-check']" routerLinkActive="active">Verificação de Consistência</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/personal-dictionary']" routerLinkActive="active">Dicionário Pessoal</a>
                                            </li>

                                            <li>
                                                <a href="https://www.enago.com/plagiarism-checker/" target="_blank">Verificação de plágio</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/credits']" routerLinkActive="active">Créditos em Trinka</a>
                                            </li>

                                            <!-- <li>
                                                <a [routerLink]="['/medical-grammar-and-spelling-checker']" routerLinkActive="active">Medical Grammar Check</a>
                                            </li> -->
                                        </ul>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="footer_menu_one">
                                        <h3>Soluções empresariais</h3>
                                        <ul class="ftr-menu">
                                            <li>
                                                <a [routerLink]="['/enterprise/life-sciences-medicine-and-pharma']" routerLinkActive="active">Ciências Biológicas, Medicina e Farmacêutica</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise/language-services-publishing-and-media']" routerLinkActive="active">Serviços de Linguagem, Publicação & Midia</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise/academic-institutions']" routerLinkActive="active">Instituições Acadêmicas</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise/k12-and-elearning']" routerLinkActive="active">K-12 e E-Learning</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise/technology-platforms']" routerLinkActive="active">Plataformas de Tecnologia</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise']" routerLinkActive="active">Integração de Empresa</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise/grammar-checker-api']" routerLinkActive="active">API de Verificação Gramatical</a>
                                            </li>
                                            <!-- <li>
                                                <a [routerLink]="['/enterprise']" routerLinkActive="active">Trinka API</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise']" routerLinkActive="active">Trinka On-Premise</a>
                                            </li> -->


                                        </ul>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="footer_menu_one">
                                        <h3>Compare</h3>
                                        <ul class="ftr-menu">

                                            <li>
                                                <a [routerLink]="['/trinka-vs-grammarly']" routerLinkActive="active">Trinka vs. Grammarly</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/trinka-vs-ginger']" routerLinkActive="active">Trinka vs. Ginger</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/trinka-vs-languagetool']" routerLinkActive="active">Trinka vs. LanguageTool</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/trinka-vs-writefull']" routerLinkActive="active">Trinka vs. Writefull</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/trinka-vs-grammarly-vs-language-tool']" routerLinkActive="active">Whitepaper</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="footer_menu_one">
                                        <h3>Recursos</h3>
                                        <ul class="ftr-menu">
                                            <li>
                                                <a [routerLink]="['/grammar-checker']" routerLinkActive="active">Verificador gramatical</a>
                                            </li>
                                            <!-- <li>
                                                <a [routerLink]="['/paraphrasing-tool']" routerLinkActive="active">
                                                    Ferramenta On-line de Paráfrase
                                                </a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/ai-content-detector']" routerLinkActive="active">
                                                    Detector de Conteúdo de IA
                                                </a>
                                            </li> -->
                                            <li>
                                                <a [routerLink]="['/punctuation-checker']" routerLinkActive="active">Verificador de Pontuação</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/spell-checker']" routerLinkActive="active">Verificador Ortográfico</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/sentence-checker']" routerLinkActive="active">Verificador de Frases</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="purple-bg">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <p>Precisa de ajuda? Entre em contato no e-mail
                        <a href="mailto:support@trinka.ai">support@trinka.ai</a>
                    </p>
                </div>
            </div>
        </div>
    </div> -->
    <div class="footer-separator"></div>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="footer-middle">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="powerd-by">
                                <div class="powered-by-left">
                                    <h3>Desenvolvido por:</h3>
                                    <p>
                                        <a href="https://www.enago.com.br/" target="_blank" class="footer_logos">
                                            <img src="../../../assets/images/enago-logo.png" alt="enago-english-editing-service" class="enago logo" />
                                        </a>
                                    </p>
                                </div>
                                <div class="powered-by-right">
                                    <p>A Enago é um nome confiável em serviços de autoria para a comunidade de pesquisa global,
                                        ajudando pesquisadores em mais de 125 países a melhorar a comunicação de suas pesquisas
                                        e obter uma publicação bem-sucedida.</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="footer_menu_one footer_menu_last">
                                <h3>Serviços da Enago</h3>
                                <ul class="ftr-menu">
                                    <li>
                                        <a href="https://www.enago.com.br/servico-de-revisao.htm" target="_blank">Edição em Inglês</a>
                                    </li>
                                    <li>
                                        <a href="https://www.enago.com.br/publication-support/" target="_blank">Suporte para Publicação</a>
                                    </li>
                                    <li>
                                        <a href="https://www.ulatus.com/pt/" target="_blank">Serviços para Tradução</a>
                                    </li>
                                    <li>
                                        <a href="https://voxtab.com/" target="_blank">Serviços de Transcrição e Legendas</a>
                                    </li>
                                    <li>
                                        <a href="https://lifesciences.enago.com/" target="_blank">Comunicações Médicas Globais</a>
                                    </li>
                                    <li>
                                        <a href="https://www.read.enago.com/" target="_blank">Revisão de literatura e ferramenta de análise</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <hr>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="footer-bottom">
                    <div class="row">
                        <div class="col-md-8">
                            <p>© Crimson AI, {{ latestYear }}. Feito na Índia.</p>
                            <ul class="ftr-menu1">
                                <li>
                                    <a href="mailto:support@trinka.ai">support@trinka.ai</a>
                                </li>
                                <li>
                                    <a id="PrivacyButton" href="https://trinka.ai/privacypolicy" target="_blank">Política de Privacidade</a>
                                </li>
                                <li>
                                    <a id="termsofserviceButton" href="https://trinka.ai/termsofservices" target="_blank">Termos de Serviços</a>
                                </li>
                            </ul>
                        </div>
                        <div class="col-md-4">
                            <div class="follow-us">
                                <h3>Siga-nos:</h3>
                                <ul class="social-media">
                                    <li>
                                        <a href="https://www.facebook.com/thetrinkaai/" rel=" no referer, no opener" target="_blank">
                                            <i class="fa fa-facebook"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.instagram.com/thetrinkaai/" rel=" no referer, no opener" target="_blank">
                                            <i class="fa fa-instagram"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://x.com/thetrinkaai" rel=" no referer, no opener" target="_blank">
                                            <i class="fa fa-twitter"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.linkedin.com/company/thetrinkaai" rel=" no referer, no opener" target="_blank">
                                            <i class="fa fa-linkedin"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.youtube.com/channel/UC1PNKZCxdUArpPVr5YFaYcA" rel=" no referer, no opener" target="_blank">
                                            <i class="fa fa-youtube-play"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>

                            <div class="language_sections" id="languageDropDown">
                                <i class="fa fa-globe" aria-hidden="true"></i>
                                <span>Português</span>
                                <ul class="drop">
                                    <li>
                                        <a href="https://www.trinka.ai">
                                            English
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.trinka.ai/jp/">
                                            日本語
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://trinka.enago.cn/">
                                            简体中文
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.trinka.ai/tw/">
                                            繁体中文
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.trinka.ai/kr/">
                                            한국어
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.trinka.ai/es/">
                                            Español
                                        </a>
                                    </li>
                                    <li class="selected">
                                        <i class="fa fa-check" aria-hidden="true"></i>
                                        <a>Português</a>
                                    </li>
                                </ul>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</footer>
<div id="emailSubscribePopup" class="modal fade show" *ngIf="subscribePopup">
	<div class="modal-dialog modal-confirm">
		<div class="modal-content">
			<div class="modal-header flex-column">
				<div class="icon-box">
					<i class="material-icons">&#xE5CA;</i>
				</div>						
				<h4 class="modal-title w-100">Thank you for subscribing to our newsletter</h4>	
                <button type="button" (click)="dismissSubcribePopup()" id="emailSubcribeButton" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
			</div>
			<div class="modal-body">
                <p>Your subscription has been confirmed.</p>
			</div>
			<div class="modal-footer justify-content-center">
				<button type="button" (click)="dismissSubcribePopup()" id="emailSubcribeButton" class="btn btn-secondary" data-dismiss="modal">OK</button>
				<!-- <button type="button" class="btn btn-danger">Delete</button> -->
                <p>Note: If at any point of time you wish to opt out from the newsletters, you can simply click on "Unsubscribe" link at the bottom of newsletter.</p>
			</div>
		</div>
	</div>
</div> 